import { Button, Input, MenuItem, Select, SelectChangeEvent, Stack } from '@mui/material'
import ClearIcon from '@mui/icons-material/Clear'
import InputB from '../../../components/InputB/InputB'
import { GLItemDTO } from '../../../DTO/GLItemDTO'

export default function LogChatMsgMarketingFields({
  glitem,
  onSaving,
  onIdle,
  onChanged,
}: {
  glitem: GLItemDTO
  onSaving: () => void
  onIdle: () => void
  onChanged: () => void
}) {
  return (
    <div className="LogChatMsg-marketingFields">
      <Stack className="LogChatMsg-marketingField" direction="column" spacing={1}>
        <label>Potenzial [€]</label>
        <InputB
          value={`${glitem.revenue_potential || '-'}`}
          returnVal={async (value: string) => {
            onSaving()
            await glitem.setRevenuePotential(parseFloat(value))
            onChanged()
            onIdle()
          }}
        />
      </Stack>
      <Stack className="LogChatMsg-marketingField" direction="column" spacing={1}>
        <label>Wahrscheinlichkeit [%]</label>
        <InputB
          value={`${glitem.revenue_probability || '-'}`}
          returnVal={async (value: string) => {
            onSaving()
            await glitem.setRevenueProbability(parseFloat(value))
            onChanged()
            onIdle()
          }}
        />
      </Stack>
      <Stack className="LogChatMsg-marketingField" direction="column" spacing={1}>
        <label>Gewichtetes Potenzial [€]</label>
        <Input disabled value={`${glitem.weighted_revenue || '-'}`} />
      </Stack>
      <Stack className="LogChatMsg-marketingField" direction="column" spacing={1}>
        <label>Quartal</label>
        <Stack direction="row" spacing={1} sx={{ alignItems: 'center' }}>
          <Select
            value={glitem.getQuarter().quarter}
            onChange={async (e: SelectChangeEvent<string>) => {
              onSaving()
              await glitem.setQuarter(e.target.value, glitem.getQuarter().year)
              onChanged()
              onIdle()
            }}
          >
            {glitem.getQuarters().map(q => (
              <MenuItem value={`${q.id}`} key={`message-${glitem.id}-quarter-${q.id}`}>
                {q.id}
              </MenuItem>
            ))}
          </Select>
          <InputB
            value={`${glitem.getQuarter().year}`}
            returnVal={async (value: string) => {
              onSaving()
              await glitem.setQuarter(glitem.getQuarter().quarter, parseInt(value, 10))
              onChanged()
              onIdle()
            }}
          />
          <Button
            variant="outlined"
            onClick={async () => {
              onSaving()
              await glitem.setQuarter('none', new Date().getFullYear())
              onChanged()
              onIdle()
            }}
            aria-label="Quartal löschen"
            sx={{ minWidth: 40, minHeight: 40 }}
          >
            <ClearIcon fontSize="small" />
          </Button>
        </Stack>
      </Stack>
    </div>
  )
}
